const ResponseActionName = "SendNewInput";
export async function processReplayInputAction(response, almeState, almeApiUtils) {
    if (response === null || response === void 0 ? void 0 : response.responseActions) {
        for (const action of response.responseActions) {
            if (action.Name === ResponseActionName) {
                const text = action.Text;
                const platform = almeApiUtils.getPlatform({ "currentEnterpriseId": action.enterpriseId });
                if (platform.enterpriseId === almeState.currentEnterpriseId) {
                    const resp = await almeApiUtils.sendAlmeInput(text);
                    almeApiUtils.appendToHistory(resp);
                }
                return;
            }
        }
    }
}
